module.exports = __webpack_public_path__ + "media/my_images/contact-4f61be4dddbef3bf6f4909ac80783b62.png";